// P23C: Known milestone keys. Add new keys here as features ship.
// The admin criteria editor and milestone management UI derive their
// option lists from this constant — no free-text entry allowed.
export const TOUR_MILESTONE_KEYS = ["onboarded"] as const;
export type TourMilestoneKey = (typeof TOUR_MILESTONE_KEYS)[number];
